import React from 'react';

type AutosaveStatusType = 'idle' | 'saved';

interface Props {
	status: AutosaveStatusType;
}

const AutosaveStatus = ({ status }: Props) => {
	if (status !== 'saved') {
		return null;
	}

	return (
		<span
			className='small position-fixed bottom-0 end-0 m-3 px-3 py-2 bg-white border rounded shadow-sm text-success'
			style={{ zIndex: 1080 }}
		>
			Progress saved
		</span>
	);
};

export default AutosaveStatus;
